/**
 * @fileoverview ICFRenderer component for the Storyteller web application.
 * Renders an Informed Consent Form (ICF) with a PDF document and a scrollable container.
 *
 * @example
 * // Basic usage
 * <ICFRenderer text={text} />
 */

import { LabelProps, rankWith, uiTypeIs } from '@jsonforms/core'
import { withJsonFormsLabelProps } from '@jsonforms/react'
import { VanillaRendererProps, withVanillaControlProps } from '@jsonforms/vanilla-renderers'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import css from './ICFRenderer.module.css'

/**
 * @function ICFRenderer
 * @description Component for rendering an Informed Consent Form (ICF).
 * @param {LabelProps & VanillaRendererProps} props - The props for the ICFRenderer component.
 * @returns {JSX.Element} The ICFRenderer component.
 */
function ICFRenderer(props: LabelProps & VanillaRendererProps) {
    const { text } = props
    return (
        <div className={css.container}>
            <div className={css.pdf_container}>
                <div className={css.pdf}>
                    <ReactMarkdown className={css.page} remarkPlugins={[remarkGfm]}>
                        {text}
                    </ReactMarkdown>
                </div>
            </div>
            <div className={css.bottomFade} />
        </div>
    )
}

export const ICFTester = rankWith(3, uiTypeIs('ICF'))

export default withVanillaControlProps(withJsonFormsLabelProps(ICFRenderer))
